/**
 *  CampaignCardCompare script file
 **/
import * as d3 from 'd3'
import moment from 'moment'
import filters from '@/filters/customFormatters'
import campaignsUtils from '@/mixins/campaignsUtils'
import { getChannelBench } from '@/utils/channelUtils'
import { CHANNEL_COLORS, CHANNEL_LABELS } from '@/utils/campaignOptions'

export default {
  name: 'CampaignCardCompare',
  mixins: [filters, campaignsUtils],
  components: {},
  props: {
    campaign: {
      type: Object,
      required: true
    },
    channel: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: '',
      required: false
    }
  },
  data () {
    return {
      kpiSelectedValues: {}
    }
  },
  watch: {},
  computed: {
    endDate () {
      return moment(this.campaign.finish_date)
    },
    startDate () {
      return moment(this.campaign.start_date)
    },
    ctrBench () {
      return getChannelBench(this.channel)
    },
    channelColor () {
      const key = this.type || this.channel.id
      return CHANNEL_COLORS[key]
    },
    channelLabel () {
      const key = this.type || this.channel.id
      return CHANNEL_LABELS[key]
    }

  },
  methods: {
    onAreaChartMouseMove (data) {
      const bisectDate = d3.bisector(d => d.date).left
      this.channel.metrics.forEach((kpi, kpiIndex) => {
        const dataIndex = bisectDate(kpi.data, data.date)
        const value = kpi.data[dataIndex].value
        // TODO: change this, store only the index and derive everything else in a computed
        this.$set(this.kpiSelectedValues, kpi.key, value)

        if (data.kpi !== kpi.key) {
          this.$refs.areachart[kpiIndex].drawCrosshair(data.date)
        }
      })
    },
    updateCharts () {
      if (this.$refs.areachart) {
        this.$refs.areachart.forEach(ref => ref.clearChart())
      }
    },
    onAreaChartMouseOut (data) {
      this.kpiSelectedValues = {}
      this.channel.metrics.forEach((kpi, kpiIndex) => {
        if (data !== kpi.key) {
          this.$refs.areachart[kpiIndex].hideCrosshair()
        }
      })
    },
    getSelectedKPIValue ({ key, total }) {
      const value = this.kpiSelectedValues[key]
      return (value || value === 0) ? value : total
    },
    getKpiChartData (kpi) {
      return [{ name: kpi.key, values: kpi.data }]
    }
  }
}
